import React, { useEffect, useRef } from 'react';

// Define a type for the component props
interface PSModalWrapperProps {
  id: string;
  title: string;
  message?: string;
  extraClass?: string;
  primaryButton?: string;
  primaryActive?: boolean;
  secondaryButton?: string;
  notStatic?: boolean;
  submit?: boolean;
  form?: boolean;
  onModalDismiss?: (param?: any) => void;
  dismissParam?: any;
  children?: JSX.Element;
}

interface PSModalElement extends HTMLElement {
  onDismiss?: () => void;
}

export const PSModalWrapper: React.FC<PSModalWrapperProps> = ({
  id,
  title,
  message,
  extraClass,
  primaryButton,
  primaryActive,
  secondaryButton,
  notStatic,
  submit,
  form,
  onModalDismiss,
  dismissParam,
  children,
}) => {
  const modalRef = useRef<PSModalElement>(null);

  useEffect(() => {
    const modalElement = modalRef.current;

    if (modalElement && onModalDismiss) {
      modalElement.onDismiss = () => onModalDismiss(dismissParam);
    }
  }, [onModalDismiss, dismissParam]);

  return (
    <ps-modal
      ref={modalRef}
      id={id}
      title={title}
      message={message}
      data-extra-class={extraClass}
      data-primary-button={primaryButton}
      data-primary-active={primaryActive ? 'true' : undefined}
      data-secondary-button={secondaryButton}
      data-not-static={notStatic ? 'true' : undefined}
      data-submit={submit ? 'true' : undefined}
      data-form={form ? 'true' : undefined}
    >
      {children}
    </ps-modal>
  );
};
